<template>
  <div class="ce-mySheets">
    <template v-if="!isDuringInitialLoad">
      <template
        v-if="hasFavorites">
        <div v-if="hasResults">
          <div>
            <div
              v-if="!isMobile"
              class="flex ce-documentResults-headerRow">
              <div class="ce-documentResults-col ce-col1">
                <SelectAllCheckbox />
              </div>
              <div class="ce-documentResults-col ce-col2">
                {{ $t('productSheets.columns.name') }}
              </div>
              <div class="ce-documentResults-col ce-col3">
                {{ $t('productSheets.columns.date') }}
              </div>
              <div class="ce-documentResults-col ce-col4">
                {{ $t('productSheets.columns.version') }}
              </div>
              <div class="ce-documentResults-col ce-col5">
                {{ $t('productSheets.columns.size') }}
              </div>
              <div class="ce-documentResults-col ce-col6" />
            </div>

            <component
              :is="resultComponent"
              v-for="hit in results.hits"
              :key="hit.id"
              :pigment="hit" />
          </div>

          <div class="my4 flex flex-column items-center">
            <div>
              <button
                v-if="canLoadMore"
                class="ce-btn ce-btn-light"
                :disabled="isLoading"
                @click.prevent="loadMoreMySheets">
                <template v-if="isLoading">
                  <fa-icon
                    icon="spinner"
                    spin />
                </template>
                <template v-else>
                  {{ $t('productSheets.cta.loadMore') }}
                </template>
              </button>
            </div>

            <div
              v-if="hasResults"
              class="mt2 ms-2 center">
              <template v-if="canLoadMore">
                {{ $t('generic.resultsHint', { loaded: results.hits.length, total: resultsTotal }) }}
              </template>
              <template v-else>
                {{ $t('generic.resultsHintAllLoaded', { total: resultsTotal }) }}
              </template>
            </div>
          </div>
        </div>

        <div
          v-else
          class="ms1 bold center">
          {{ $t('productSheets.mySheets.noResults') }}

          <div
            class="mt2"
            v-if="hasActiveFilters">
            <button
              class="ce-btn ce-btn-light ce-btn--small"
              @click.prevent="$store.dispatch('resetFilters')">
              {{ $t('productSearch.products.resetFiltersCta') }}
            </button>
          </div>
        </div>
      </template>

      <div
        v-else
        class="ms1 bold center">
        {{ $t('productSheets.mySheets.noFavorites') }}
      </div>

      <basket-actions-bar
        class="my4" />
    </template>

    <div
      class="flex justify-center ms3 py4"
      v-else>
      <fa-icon
        icon="spinner"
        spin />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import DocumentResult from 'components/product-sheets/DocumentResult.vue';
import BasketActionsBar from 'components/product-sheets/BasketActionsBar.vue';
import MobileDocumentResult from 'components/product-sheets/mobile/DocumentResult.vue';
import SelectAllCheckbox from 'components/product-sheets/SelectAllCheckbox.vue';

export default {
  data() {
    return {
      isDuringInitialLoad: true
    };
  },
  mounted() {
    this.setup();
  },
  watch: {
    urlFilters() {
      this.fetchMySheets();
    }
  },
  components: { DocumentResult, BasketActionsBar, SelectAllCheckbox },
  computed: {
    ...mapState(['favorites', 'isLoading']),
    ...mapGetters(['urlFilters', 'results', 'isMobile', 'hasActiveFilters', 'canLoadMore', 'resultsTotal']),
    hasFavorites() {
      return this.favorites
        && Array.isArray(this.favorites)
        && this.favorites.length > 0;
    },
    resultComponent() {
      return this.isMobile ? MobileDocumentResult : DocumentResult;
    },
    hasResults() {
      return this.results.hits.length > 0;
    }
  },
  methods: {
    ...mapActions(['fetchMySheets', 'loadMoreMySheets']),
    async setup() {
      await this.fetchMySheets();
      this.isDuringInitialLoad = false;

      this.$trackEvent(
        'Page View',
        'View MySheets',
        {
          url: location.pathname
        }
      );
    },
  }
};
</script>

<style lang="less">
@import (reference) '~styles/includes/base';

.ce-mySheets {
  .ce-documentResults-headerRow {
    border-bottom: 2px solid @color-mono-80;
    padding: @space-3 @space-2;
    font-weight: bold;
  }
}
</style>
